var map = {
	"./_lib/buildFormatLongFn/index.js": "h49F",
	"./_lib/buildLocalizeFn/index.js": "rZ5Z",
	"./_lib/buildMatchFn/index.js": "yfUD",
	"./_lib/buildMatchPatternFn/index.js": "le+r",
	"./af/_lib/formatDistance/index.js": "z3t3",
	"./af/_lib/formatLong/index.js": "Kcpp",
	"./af/_lib/formatRelative/index.js": "qQQ7",
	"./af/_lib/localize/index.js": "VV3z",
	"./af/_lib/match/index.js": "6pIe",
	"./af/index.js": "7pD0",
	"./ar-DZ/_lib/formatDistance/index.js": "1N6k",
	"./ar-DZ/_lib/formatLong/index.js": "Fxhi",
	"./ar-DZ/_lib/formatRelative/index.js": "+m2c",
	"./ar-DZ/_lib/localize/index.js": "IzMj",
	"./ar-DZ/_lib/match/index.js": "MAR7",
	"./ar-DZ/index.js": "KL66",
	"./ar-MA/_lib/formatDistance/index.js": "87Dc",
	"./ar-MA/_lib/formatLong/index.js": "aykJ",
	"./ar-MA/_lib/formatRelative/index.js": "V1ve",
	"./ar-MA/_lib/localize/index.js": "rf3q",
	"./ar-MA/_lib/match/index.js": "KC5K",
	"./ar-MA/index.js": "6EIj",
	"./ar-SA/_lib/formatDistance/index.js": "gQV8",
	"./ar-SA/_lib/formatLong/index.js": "hWCd",
	"./ar-SA/_lib/formatRelative/index.js": "wDLH",
	"./ar-SA/_lib/localize/index.js": "drZx",
	"./ar-SA/_lib/match/index.js": "Df67",
	"./ar-SA/index.js": "V2nH",
	"./az/_lib/formatDistance/index.js": "/eI1",
	"./az/_lib/formatLong/index.js": "JDHn",
	"./az/_lib/formatRelative/index.js": "bG7V",
	"./az/_lib/localize/index.js": "9Qj1",
	"./az/_lib/match/index.js": "WSb0",
	"./az/index.js": "LJL1",
	"./be/_lib/formatDistance/index.js": "JbKt",
	"./be/_lib/formatLong/index.js": "3tT/",
	"./be/_lib/formatRelative/index.js": "gBwy",
	"./be/_lib/localize/index.js": "Q1WG",
	"./be/_lib/match/index.js": "tm8q",
	"./be/index.js": "3NsD",
	"./bg/_lib/formatDistance/index.js": "vGUi",
	"./bg/_lib/formatLong/index.js": "2ND0",
	"./bg/_lib/formatRelative/index.js": "fEBG",
	"./bg/_lib/localize/index.js": "Ifde",
	"./bg/_lib/match/index.js": "fWaN",
	"./bg/index.js": "gAGu",
	"./bn/_lib/formatDistance/index.js": "pG+O",
	"./bn/_lib/formatLong/index.js": "3/nJ",
	"./bn/_lib/formatRelative/index.js": "Vs64",
	"./bn/_lib/localize/index.js": "I0qv",
	"./bn/_lib/match/index.js": "EXr9",
	"./bn/index.js": "btr2",
	"./ca/_lib/formatDistance/index.js": "Jj+T",
	"./ca/_lib/formatLong/index.js": "sD1U",
	"./ca/_lib/formatRelative/index.js": "Hi9c",
	"./ca/_lib/localize/index.js": "+XQ7",
	"./ca/_lib/match/index.js": "nvA5",
	"./ca/index.js": "o+mV",
	"./cs/_lib/formatDistance/index.js": "JTXs",
	"./cs/_lib/formatLong/index.js": "k789",
	"./cs/_lib/formatRelative/index.js": "3ji3",
	"./cs/_lib/localize/index.js": "b0Zj",
	"./cs/_lib/match/index.js": "tF4h",
	"./cs/index.js": "4Jid",
	"./cy/_lib/formatDistance/index.js": "sDqx",
	"./cy/_lib/formatLong/index.js": "hAx1",
	"./cy/_lib/formatRelative/index.js": "NCXW",
	"./cy/_lib/localize/index.js": "qjzi",
	"./cy/_lib/match/index.js": "FXbp",
	"./cy/index.js": "cEMF",
	"./da/_lib/formatDistance/index.js": "flV5",
	"./da/_lib/formatLong/index.js": "JWk9",
	"./da/_lib/formatRelative/index.js": "M1dZ",
	"./da/_lib/localize/index.js": "9/63",
	"./da/_lib/match/index.js": "Zv7K",
	"./da/index.js": "aHQV",
	"./de/_lib/formatDistance/index.js": "fvJP",
	"./de/_lib/formatLong/index.js": "HtGV",
	"./de/_lib/formatRelative/index.js": "Vji7",
	"./de/_lib/localize/index.js": "IF2K",
	"./de/_lib/match/index.js": "wkj/",
	"./de/index.js": "Tv5l",
	"./el/_lib/formatDistance/index.js": "kIdr",
	"./el/_lib/formatLong/index.js": "+ATo",
	"./el/_lib/formatRelative/index.js": "T9YK",
	"./el/_lib/localize/index.js": "zhtG",
	"./el/_lib/match/index.js": "kF4b",
	"./el/index.js": "qs9i",
	"./en-AU/_lib/formatLong/index.js": "5AjI",
	"./en-AU/index.js": "Mql6",
	"./en-CA/_lib/formatDistance/index.js": "i8L2",
	"./en-CA/_lib/formatLong/index.js": "+9Jd",
	"./en-CA/index.js": "Ehcm",
	"./en-GB/_lib/formatLong/index.js": "O5uA",
	"./en-GB/index.js": "Binh",
	"./en-IN/_lib/formatLong/index.js": "scBD",
	"./en-IN/index.js": "qHFG",
	"./en-NZ/_lib/formatLong/index.js": "Ux2f",
	"./en-NZ/index.js": "tkKD",
	"./en-US/_lib/formatDistance/index.js": "LOnz",
	"./en-US/_lib/formatLong/index.js": "/t/g",
	"./en-US/_lib/formatRelative/index.js": "62qe",
	"./en-US/_lib/localize/index.js": "1nMn",
	"./en-US/_lib/match/index.js": "Chy2",
	"./en-US/index.js": "SUp7",
	"./eo/_lib/formatDistance/index.js": "nwUZ",
	"./eo/_lib/formatLong/index.js": "Lg7V",
	"./eo/_lib/formatRelative/index.js": "ddep",
	"./eo/_lib/localize/index.js": "4ocS",
	"./eo/_lib/match/index.js": "n+dt",
	"./eo/index.js": "RQ02",
	"./es/_lib/formatDistance/index.js": "M24q",
	"./es/_lib/formatLong/index.js": "5ugw",
	"./es/_lib/formatRelative/index.js": "ag9u",
	"./es/_lib/localize/index.js": "4rTR",
	"./es/_lib/match/index.js": "7EX4",
	"./es/index.js": "Dl0Z",
	"./et/_lib/formatDistance/index.js": "+ogj",
	"./et/_lib/formatLong/index.js": "vM0A",
	"./et/_lib/formatRelative/index.js": "hoJO",
	"./et/_lib/localize/index.js": "cUAV",
	"./et/_lib/match/index.js": "szrr",
	"./et/index.js": "pc25",
	"./eu/_lib/formatDistance/index.js": "+Mrc",
	"./eu/_lib/formatLong/index.js": "UGeb",
	"./eu/_lib/formatRelative/index.js": "fmg3",
	"./eu/_lib/localize/index.js": "vq5+",
	"./eu/_lib/match/index.js": "K+HN",
	"./eu/index.js": "ZX8i",
	"./fa-IR/_lib/formatDistance/index.js": "j1TT",
	"./fa-IR/_lib/formatLong/index.js": "a2dV",
	"./fa-IR/_lib/formatRelative/index.js": "17Je",
	"./fa-IR/_lib/localize/index.js": "rmdD",
	"./fa-IR/_lib/match/index.js": "8D+C",
	"./fa-IR/index.js": "gCSE",
	"./fi/_lib/formatDistance/index.js": "gAqS",
	"./fi/_lib/formatLong/index.js": "C821",
	"./fi/_lib/formatRelative/index.js": "53uH",
	"./fi/_lib/localize/index.js": "P59E",
	"./fi/_lib/match/index.js": "deI0",
	"./fi/index.js": "YAZG",
	"./fr-CA/_lib/formatLong/index.js": "A1sV",
	"./fr-CA/index.js": "VDKA",
	"./fr-CH/_lib/formatDistance/index.js": "BRbk",
	"./fr-CH/_lib/formatLong/index.js": "2F+C",
	"./fr-CH/_lib/formatRelative/index.js": "Gls9",
	"./fr-CH/_lib/formatters/index.js": "QNub",
	"./fr-CH/_lib/localize/index.js": "TltP",
	"./fr-CH/_lib/match/index.js": "mJ8+",
	"./fr-CH/index.js": "1V17",
	"./fr/_lib/formatDistance/index.js": "d4MZ",
	"./fr/_lib/formatLong/index.js": "/kWT",
	"./fr/_lib/formatRelative/index.js": "I7A4",
	"./fr/_lib/formatters/index.js": "Q9UJ",
	"./fr/_lib/localize/index.js": "E9Ne",
	"./fr/_lib/match/index.js": "pPVU",
	"./fr/index.js": "Vu/e",
	"./gd/_lib/formatDistance/index.js": "H6nP",
	"./gd/_lib/formatLong/index.js": "wbmm",
	"./gd/_lib/formatRelative/index.js": "NOpu",
	"./gd/_lib/localize/index.js": "YLdU",
	"./gd/_lib/match/index.js": "/HaZ",
	"./gd/index.js": "yVEL",
	"./gl/_lib/formatDistance/index.js": "YwVI",
	"./gl/_lib/formatLong/index.js": "yYzC",
	"./gl/_lib/formatRelative/index.js": "4c+B",
	"./gl/_lib/localize/index.js": "0ARz",
	"./gl/_lib/match/index.js": "zn4r",
	"./gl/index.js": "v/wh",
	"./gu/_lib/formatDistance/index.js": "j0Gh",
	"./gu/_lib/formatLong/index.js": "FRI0",
	"./gu/_lib/formatRelative/index.js": "9eYC",
	"./gu/_lib/localize/index.js": "9gxE",
	"./gu/_lib/match/index.js": "zRX6",
	"./gu/index.js": "tbIR",
	"./he/_lib/formatDistance/index.js": "wJoL",
	"./he/_lib/formatLong/index.js": "vE5J",
	"./he/_lib/formatRelative/index.js": "4VDY",
	"./he/_lib/localize/index.js": "NXQM",
	"./he/_lib/match/index.js": "Qw39",
	"./he/index.js": "H9yC",
	"./hi/_lib/formatDistance/index.js": "CyeN",
	"./hi/_lib/formatLong/index.js": "p2BO",
	"./hi/_lib/formatRelative/index.js": "ksn2",
	"./hi/_lib/localize/index.js": "GegZ",
	"./hi/_lib/match/index.js": "KKA+",
	"./hi/index.js": "W7hA",
	"./hr/_lib/formatDistance/index.js": "gW40",
	"./hr/_lib/formatLong/index.js": "p3+w",
	"./hr/_lib/formatRelative/index.js": "IL2K",
	"./hr/_lib/localize/index.js": "um+F",
	"./hr/_lib/match/index.js": "u6Xc",
	"./hr/index.js": "yICP",
	"./hu/_lib/formatDistance/index.js": "K7iA",
	"./hu/_lib/formatLong/index.js": "Q4wd",
	"./hu/_lib/formatRelative/index.js": "ML9g",
	"./hu/_lib/localize/index.js": "1+Pu",
	"./hu/_lib/match/index.js": "pptg",
	"./hu/index.js": "9pn7",
	"./hy/_lib/formatDistance/index.js": "Umok",
	"./hy/_lib/formatLong/index.js": "/ZEM",
	"./hy/_lib/formatRelative/index.js": "mTkO",
	"./hy/_lib/localize/index.js": "THiy",
	"./hy/_lib/match/index.js": "G5VQ",
	"./hy/index.js": "+9v1",
	"./id/_lib/formatDistance/index.js": "xvBq",
	"./id/_lib/formatLong/index.js": "X9Yv",
	"./id/_lib/formatRelative/index.js": "KIGv",
	"./id/_lib/localize/index.js": "HAH0",
	"./id/_lib/match/index.js": "FRA5",
	"./id/index.js": "AJeH",
	"./is/_lib/formatDistance/index.js": "tvyK",
	"./is/_lib/formatLong/index.js": "+Po5",
	"./is/_lib/formatRelative/index.js": "1sHi",
	"./is/_lib/localize/index.js": "TVb8",
	"./is/_lib/match/index.js": "DavN",
	"./is/index.js": "V3M7",
	"./it/_lib/formatDistance/index.js": "0P16",
	"./it/_lib/formatLong/index.js": "gzfW",
	"./it/_lib/formatRelative/index.js": "4nAg",
	"./it/_lib/localize/index.js": "8Y6q",
	"./it/_lib/match/index.js": "trAM",
	"./it/index.js": "tt/w",
	"./ja/_lib/formatDistance/index.js": "aUKd",
	"./ja/_lib/formatLong/index.js": "HxwP",
	"./ja/_lib/formatRelative/index.js": "dU+q",
	"./ja/_lib/localize/index.js": "S8LM",
	"./ja/_lib/match/index.js": "S011",
	"./ja/index.js": "o7QX",
	"./ka/_lib/formatDistance/index.js": "F2lK",
	"./ka/_lib/formatLong/index.js": "PRgI",
	"./ka/_lib/formatRelative/index.js": "QLqO",
	"./ka/_lib/localize/index.js": "Xnxf",
	"./ka/_lib/match/index.js": "Cz48",
	"./ka/index.js": "AWc+",
	"./kk/_lib/formatDistance/index.js": "U518",
	"./kk/_lib/formatLong/index.js": "IIyk",
	"./kk/_lib/formatRelative/index.js": "d8li",
	"./kk/_lib/localize/index.js": "EpVs",
	"./kk/_lib/match/index.js": "2QaT",
	"./kk/index.js": "Ez6s",
	"./kn/_lib/formatDistance/index.js": "Ad6V",
	"./kn/_lib/formatLong/index.js": "6fTU",
	"./kn/_lib/formatRelative/index.js": "exIJ",
	"./kn/_lib/localize/index.js": "NRAs",
	"./kn/_lib/match/index.js": "Kpzy",
	"./kn/index.js": "9QC/",
	"./ko/_lib/formatDistance/index.js": "oQkC",
	"./ko/_lib/formatLong/index.js": "fyn6",
	"./ko/_lib/formatRelative/index.js": "iUyQ",
	"./ko/_lib/localize/index.js": "i/dm",
	"./ko/_lib/match/index.js": "gPuH",
	"./ko/index.js": "0yCi",
	"./lb/_lib/formatDistance/index.js": "D3jk",
	"./lb/_lib/formatLong/index.js": "9pid",
	"./lb/_lib/formatRelative/index.js": "Uipq",
	"./lb/_lib/localize/index.js": "Ynfw",
	"./lb/_lib/match/index.js": "/hwj",
	"./lb/index.js": "5t0E",
	"./lt/_lib/formatDistance/index.js": "Jvs5",
	"./lt/_lib/formatLong/index.js": "MNgI",
	"./lt/_lib/formatRelative/index.js": "j06q",
	"./lt/_lib/localize/index.js": "Jb1g",
	"./lt/_lib/match/index.js": "809/",
	"./lt/index.js": "fj+S",
	"./lv/_lib/formatDistance/index.js": "6jdY",
	"./lv/_lib/formatLong/index.js": "14Iq",
	"./lv/_lib/formatRelative/index.js": "cd7e",
	"./lv/_lib/localize/index.js": "9exF",
	"./lv/_lib/match/index.js": "p2rL",
	"./lv/index.js": "hlx1",
	"./mk/_lib/formatDistance/index.js": "HE6h",
	"./mk/_lib/formatLong/index.js": "mkZz",
	"./mk/_lib/formatRelative/index.js": "urLk",
	"./mk/_lib/localize/index.js": "pX1E",
	"./mk/_lib/match/index.js": "nU5B",
	"./mk/index.js": "YMcP",
	"./ms/_lib/formatDistance/index.js": "wSbe",
	"./ms/_lib/formatLong/index.js": "u+BE",
	"./ms/_lib/formatRelative/index.js": "e19H",
	"./ms/_lib/localize/index.js": "o7H8",
	"./ms/_lib/match/index.js": "Ekjf",
	"./ms/index.js": "4Ewa",
	"./mt/_lib/formatDistance/index.js": "Xv+t",
	"./mt/_lib/formatLong/index.js": "owsI",
	"./mt/_lib/formatRelative/index.js": "I4ZA",
	"./mt/_lib/localize/index.js": "DzjR",
	"./mt/_lib/match/index.js": "JKa3",
	"./mt/index.js": "rcBh",
	"./nb/_lib/formatDistance/index.js": "VFz3",
	"./nb/_lib/formatLong/index.js": "mPLo",
	"./nb/_lib/formatRelative/index.js": "2CEg",
	"./nb/_lib/localize/index.js": "m4rL",
	"./nb/_lib/match/index.js": "yXE3",
	"./nb/index.js": "jagT",
	"./nl-BE/_lib/formatDistance/index.js": "1N9N",
	"./nl-BE/_lib/formatLong/index.js": "GLUX",
	"./nl-BE/_lib/formatRelative/index.js": "LP4D",
	"./nl-BE/_lib/localize/index.js": "vGr9",
	"./nl-BE/_lib/match/index.js": "96v4",
	"./nl-BE/index.js": "xvR1",
	"./nl/_lib/formatDistance/index.js": "CO4U",
	"./nl/_lib/formatLong/index.js": "1iHm",
	"./nl/_lib/formatRelative/index.js": "TLPu",
	"./nl/_lib/localize/index.js": "BpVG",
	"./nl/_lib/match/index.js": "PS8X",
	"./nl/index.js": "2/5A",
	"./nn/_lib/formatDistance/index.js": "YicD",
	"./nn/_lib/formatLong/index.js": "gh2r",
	"./nn/_lib/formatRelative/index.js": "9be/",
	"./nn/_lib/localize/index.js": "tXMU",
	"./nn/_lib/match/index.js": "g3qA",
	"./nn/index.js": "s3XK",
	"./pl/_lib/formatDistance/index.js": "HjSe",
	"./pl/_lib/formatLong/index.js": "8vrM",
	"./pl/_lib/formatRelative/index.js": "sI4E",
	"./pl/_lib/localize/index.js": "3nfD",
	"./pl/_lib/match/index.js": "Z4CO",
	"./pl/index.js": "f1Lz",
	"./pt-BR/_lib/formatDistance/index.js": "0y8z",
	"./pt-BR/_lib/formatLong/index.js": "cBkn",
	"./pt-BR/_lib/formatRelative/index.js": "w/VN",
	"./pt-BR/_lib/localize/index.js": "LJ5P",
	"./pt-BR/_lib/match/index.js": "NjiN",
	"./pt-BR/index.js": "/AjS",
	"./pt/_lib/formatDistance/index.js": "uNI+",
	"./pt/_lib/formatLong/index.js": "SRJ0",
	"./pt/_lib/formatRelative/index.js": "qygu",
	"./pt/_lib/localize/index.js": "Eje4",
	"./pt/_lib/match/index.js": "x1Jm",
	"./pt/index.js": "M4eM",
	"./ro/_lib/formatDistance/index.js": "EmW3",
	"./ro/_lib/formatLong/index.js": "m2co",
	"./ro/_lib/formatRelative/index.js": "iOnW",
	"./ro/_lib/localize/index.js": "KNd6",
	"./ro/_lib/match/index.js": "Phhb",
	"./ro/index.js": "T0ua",
	"./ru/_lib/formatDistance/index.js": "pLfm",
	"./ru/_lib/formatLong/index.js": "CXlP",
	"./ru/_lib/formatRelative/index.js": "T1fu",
	"./ru/_lib/localize/index.js": "ik1E",
	"./ru/_lib/match/index.js": "Vy49",
	"./ru/index.js": "Dw+G",
	"./sk/_lib/formatDistance/index.js": "+mmY",
	"./sk/_lib/formatLong/index.js": "1nJo",
	"./sk/_lib/formatRelative/index.js": "ex5D",
	"./sk/_lib/localize/index.js": "T3MD",
	"./sk/_lib/match/index.js": "Bx/l",
	"./sk/index.js": "epFg",
	"./sl/_lib/formatDistance/index.js": "Td3P",
	"./sl/_lib/formatLong/index.js": "9Wc3",
	"./sl/_lib/formatRelative/index.js": "UW5p",
	"./sl/_lib/localize/index.js": "pMOz",
	"./sl/_lib/match/index.js": "2wwz",
	"./sl/index.js": "WhfY",
	"./sr-Latn/_lib/formatDistance/index.js": "qQ/L",
	"./sr-Latn/_lib/formatLong/index.js": "i7dk",
	"./sr-Latn/_lib/formatRelative/index.js": "5/vY",
	"./sr-Latn/_lib/localize/index.js": "ZUnH",
	"./sr-Latn/_lib/match/index.js": "orYJ",
	"./sr-Latn/index.js": "eZKC",
	"./sr/_lib/formatDistance/index.js": "PWae",
	"./sr/_lib/formatLong/index.js": "cw0K",
	"./sr/_lib/formatRelative/index.js": "OqZs",
	"./sr/_lib/localize/index.js": "deoz",
	"./sr/_lib/match/index.js": "o6iE",
	"./sr/index.js": "3oQ0",
	"./sv/_lib/formatDistance/index.js": "8QBz",
	"./sv/_lib/formatLong/index.js": "OD8O",
	"./sv/_lib/formatRelative/index.js": "l9Xj",
	"./sv/_lib/localize/index.js": "MRvT",
	"./sv/_lib/match/index.js": "TGKQ",
	"./sv/index.js": "XR5Q",
	"./ta/_lib/formatDistance/index.js": "NLjV",
	"./ta/_lib/formatLong/index.js": "2aVu",
	"./ta/_lib/formatRelative/index.js": "4umz",
	"./ta/_lib/localize/index.js": "eSJP",
	"./ta/_lib/match/index.js": "MvEU",
	"./ta/index.js": "j7sa",
	"./te/_lib/formatDistance/index.js": "T7IF",
	"./te/_lib/formatLong/index.js": "QZAD",
	"./te/_lib/formatRelative/index.js": "pwY2",
	"./te/_lib/localize/index.js": "B7mx",
	"./te/_lib/match/index.js": "/jLD",
	"./te/index.js": "jWc2",
	"./th/_lib/formatDistance/index.js": "udeC",
	"./th/_lib/formatLong/index.js": "p3CN",
	"./th/_lib/formatRelative/index.js": "wFTy",
	"./th/_lib/localize/index.js": "32wX",
	"./th/_lib/match/index.js": "0EFT",
	"./th/index.js": "LKOs",
	"./tr/_lib/formatDistance/index.js": "EbwR",
	"./tr/_lib/formatLong/index.js": "h++d",
	"./tr/_lib/formatRelative/index.js": "OPGH",
	"./tr/_lib/localize/index.js": "lfyL",
	"./tr/_lib/match/index.js": "MQ7Q",
	"./tr/index.js": "+r2B",
	"./ug/_lib/formatDistance/index.js": "6YTo",
	"./ug/_lib/formatLong/index.js": "IsOz",
	"./ug/_lib/formatRelative/index.js": "9JD9",
	"./ug/_lib/localize/index.js": "SjyT",
	"./ug/_lib/match/index.js": "Zb+W",
	"./ug/index.js": "of7y",
	"./uk/_lib/formatDistance/index.js": "Nzgk",
	"./uk/_lib/formatLong/index.js": "0GsP",
	"./uk/_lib/formatRelative/index.js": "3Irb",
	"./uk/_lib/localize/index.js": "Gwdo",
	"./uk/_lib/match/index.js": "cAe6",
	"./uk/index.js": "2/+4",
	"./uz/_lib/formatDistance/index.js": "kLXq",
	"./uz/_lib/formatLong/index.js": "r4/F",
	"./uz/_lib/formatRelative/index.js": "2HDX",
	"./uz/_lib/localize/index.js": "PH7Q",
	"./uz/_lib/match/index.js": "dX8a",
	"./uz/index.js": "MaHQ",
	"./vi/_lib/formatDistance/index.js": "IU8o",
	"./vi/_lib/formatLong/index.js": "0LtD",
	"./vi/_lib/formatRelative/index.js": "/tRK",
	"./vi/_lib/localize/index.js": "GBoY",
	"./vi/_lib/match/index.js": "BYFH",
	"./vi/index.js": "NAUq",
	"./zh-CN/_lib/formatDistance/index.js": "jcZm",
	"./zh-CN/_lib/formatLong/index.js": "l46P",
	"./zh-CN/_lib/formatRelative/index.js": "FhwC",
	"./zh-CN/_lib/localize/index.js": "Zd/b",
	"./zh-CN/_lib/match/index.js": "Wra6",
	"./zh-CN/index.js": "9oP8",
	"./zh-TW/_lib/formatDistance/index.js": "BGT6",
	"./zh-TW/_lib/formatLong/index.js": "wDkS",
	"./zh-TW/_lib/formatRelative/index.js": "6/Wb",
	"./zh-TW/_lib/localize/index.js": "pNkz",
	"./zh-TW/_lib/match/index.js": "L8or",
	"./zh-TW/index.js": "sy4g"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "/iJ5";